import React, { memo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { CardView, Spacer } from 'design-system';
import AllocationSlider from 'design-system/AllocationSlider';
import Logo from 'design-system/Logo';
import Text from 'design-system/Text';
import { IconTrash } from 'design-system/icons/IconTrash';
import { hitSlopS, rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useStockMeta from '../hooks/useStockMeta';
import { isWeb } from '../../../constants';
const AllocationFundCard = ({ assetId, percentage, maximumValue, onPercentageChange, onDelete, onSlidingStart, onSlidingComplete, }) => {
    const meta = useStockMeta(assetId);
    const styles = useStyles(styleSet);
    const { width } = useAppFrameDimensions(isWeb);
    return (<CardView noMarginTop style={styles.card}>
      <View style={styles.header}>
        <Logo R44 uri={meta?.iconUrl} resizeMode="contain"/>
        <View style={styles.titleContainer}>
          <Text Text-16>{meta?.name ?? ''}</Text>
        </View>
        <Text Numbers-16>{parseFloat(percentage.toFixed(2))}%</Text>
        <TouchableOpacity onPress={onDelete} hitSlop={hitSlopS} style={styles.trash}>
          <IconTrash colorKey="secondaryLight"/>
        </TouchableOpacity>
      </View>
      <Spacer h={8}/>
      <AllocationSlider value={percentage} sliderWidth={width - rem(64)} accessibilityLabel={meta?.name ? `${meta.name} allocation` : 'Allocation'} maximumValue={maximumValue} onValueChange={onPercentageChange} onSlidingStart={onSlidingStart} onSlidingComplete={onSlidingComplete}/>
    </CardView>);
};
const styleSet = createStyleSheets(() => ({
    card: {
        paddingHorizontal: rem(16),
        paddingVertical: rem(16),
        paddingBottom: rem(8),
    },
    header: {
        gap: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
    },
    titleContainer: {
        flex: 1,
    },
    trash: { opacity: 0.8 },
}));
export default memo(AllocationFundCard);
